import { EditFilled } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Space,
} from "antd";
import { useEffect, useState } from "react";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";

function SettingsModal({ settings = [] }) {
  const [data, setData] = useState([]);
  const [updatedData, setUpdatedData] = useState(null);

  useEffect(() => {
    setData(settings);
  }, [settings]);

  const handleUpdate = async (values) => {
    let res = await apiRequest({
      path: apiPaths.siteSettings,
      method: "PUT",
      data: values.data,
    });

    if (res.error) {
      message.error(res.error_description);
      return;
    }
    setData([...values.data]);
    setUpdatedData(null);
  };

  return (
    <div style={{ width: 350, padding: 20 }}>
      <div
        style={{
          display: "flex",
          marginBottom: 10,
          justifyContent: "space-between",
        }}
      >
        <div style={{ fontSize: 20 }}>Other Settings</div>
        <Button
          type="link"
          onClick={() => {
            setUpdatedData(settings);
          }}
        >
          <EditFilled />
        </Button>
      </div>
      <div style={{ border: "1px solid #b7b7b750" }}>
        <Row
          style={{
            padding: 5,
            borderBottom: "1px solid #b7b7b750",
          }}
        >
          <Col span={14} style={{ fontWeight: "bold", padding: 5 }}>
            {"Name"}
          </Col>
          <Col
            span={10}
            style={{
              fontWeight: "bold",
              borderLeft: "1px solid #b7b7b730",
              padding: 5,
            }}
          >
            {"Value"}
          </Col>
        </Row>
        {data.map((item, idx) => (
          <Row
            style={{
              padding: 5,
              borderBottom: "1px solid #b7b7b730",
            }}
            key={idx}
          >
            <Col span={14} style={{ padding: 5 }}>
              {item.label}
            </Col>
            <Col span={10} style={{ padding: 5 }}>
              {item.value}
            </Col>
          </Row>
        ))}
      </div>

      {updatedData ? (
        <Modal
          title={"Update Settings"}
          centered
          width={500}
          visible={true}
          onCancel={() => {
            setUpdatedData(null);
          }}
          footer={null}
        >
          <Row gutter={[12, 12]}>
            <Col span={14} style={{ fontWeight: "bold" }}>
              {"Name"}
            </Col>
            <Col span={10} style={{ fontWeight: "bold" }}>
              {"Value"}
            </Col>
          </Row>
          <Form
            name="dynamic_form_nest_item"
            onFinish={handleUpdate}
            style={{
              maxWidth: 600,
            }}
            initialValues={{
              data: updatedData,
            }}
            autoComplete="off"
          >
            <Form.List name="data">
              {(fields) => (
                <>
                  {fields.map(({ key, name, ...restField }, idx) => (
                    <Row key={key} gutter={[12, 12]}>
                      <Col span={14}>
                        <div>{updatedData[idx].label}</div>
                      </Col>
                      <Col span={10}>
                        <Form.Item
                          {...restField}
                          name={[name, "value"]}
                          rules={[
                            {
                              required: true,
                              message: "Missing value",
                            },
                          ]}
                        >
                          <Input placeholder="Value" />
                        </Form.Item>
                      </Col>
                    </Row>
                  ))}
                </>
              )}
            </Form.List>
            <Form.Item>
              <Space style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  onClick={() => {
                    setUpdatedData(null);
                  }}
                >
                  Cancel
                </Button>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      ) : null}
    </div>
  );
}

export default SettingsModal;
